import * as yup from 'yup'

import constants from 'constants/index'

const { STATUSES } = constants.dai.solutions

const schema = yup.object().shape({
  global: yup
    .string()
    .oneOf([...Object.values(STATUSES), null])
    .nullable(),
})

export default schema
